import React from 'react';
import { Button, Descriptions, Card } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { IUsageEvent } from './UsageEvent';

type UsageEventDetailProps = {
  event?: IUsageEvent;
  onClickBack: () => void;
};

export default function UsageEventDetails(props: UsageEventDetailProps) {
  const event = props.event;

  if (event) {
    const { event_type, plan, job_id, created_at, logged_at, user_id, status, usage, metadata } = event;

    const eventItems = [
      { key: '1', label: 'UsageEvent Type', children: event_type },
      { key: '2', label: 'User', children: user_id },
      { key: '3', label: 'Plan', children: plan },
      { key: '4', label: 'Status', children: status },
      { key: '5', label: 'Created At', children: created_at },
      { key: '6', label: 'Logged At', children: logged_at },
      { key: '7', label: 'Job ID', children: job_id },
    ];

    const metadataItems = Object.entries(metadata).map(([key, val], index) => ({
      key: `meta-${index}`,
      label: key,
      children: val,
    }));

    const gridStyle = {
      width: '100%',
    };

    return (
      <div className='container'>
        <Card className='event-detail-card'>
          <Card.Grid style={gridStyle}>
            <Descriptions title='Event Details' bordered size='small' column={1}>
              {eventItems.map((item) => (
                <Descriptions.Item {...item} />
              ))}
            </Descriptions>
          </Card.Grid>

          <Card.Grid style={gridStyle}>
            <Descriptions title='Usage' bordered size='small' column={8}>
              {Object.entries(usage).map(([key, val]) => (
                <Descriptions.Item key={key} label={key} children={val} />
              ))}
            </Descriptions>
          </Card.Grid>

          <Card.Grid style={gridStyle}>
            <Descriptions title='Metadata' bordered size='small' column={4}>
              {metadataItems.map((item) => (
                <Descriptions.Item {...item} />
              ))}
            </Descriptions>
          </Card.Grid>
        </Card>

        <div style={{ marginTop: '16px' }}>
          <Button onClick={props.onClickBack} icon={<ArrowLeftOutlined />}>
            Til baka
          </Button>
        </div>
      </div>
    );
  }

  // If no event, render an empty container
  return <div className='container'></div>;
}
